import angular from 'angular';
import $ from 'jquery';

angular.module('datepicker').directive('datepicker', datepicker);

datepicker.$inject = ['$timeout'];

function datepicker($timeout) {
  const directive = {
    controller: 'DatepickerCtrl',
    controllerAs: 'vm',
    template: require('../datepicker/datepicker.html'),
    link,
    restrict: 'AE',
    scope: {
      unavailable: '=?',
      onlyFutureDates: '=?',
    },
  };

  return directive;

  function link(scope, element) {
    $timeout(function () {
      $(element).datepicker({
        dateFormat: 'yy-mm-dd',
        showOtherMonths: true,
        firstDay: 1,
        minDate: scope.onlyFutureDates ? '+0D' : null,
        beforeShowDay: scope.unavailable ? unavailable : null,
      });
    }, 100);

    function unavailable(date) {
      const ymd = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`;

      if ($.inArray(ymd, scope.unavailable) === -1) {
        return [true, ''];
      }

      return [false, '', 'Unavailable'];
    }
  }
}
